import { AxiosResponse } from 'axios';
import camelcaseKeys from 'camelcase-keys';
import { QueryKey, useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

type Props<T> = {
  queryKey?: string;
  req: () => Promise<AxiosResponse<T>>;
  deps?: QueryKey;
  options?: UseQueryOptions;
};

export const useQueryWrapper = <T>({ queryKey, req, deps = [], options }: Props<T>): UseQueryResult<T> => {
  const k = Array.isArray(deps) ? [queryKey, ...deps] : [queryKey];
  const result = useQuery(
    k,
    async () => {
      try {
        const res = await req();
        return camelcaseKeys(res.data, { deep: true });
      } catch (e) {
        throw e.response;
      }
    },
    options
  ) as UseQueryResult<T>;

  return result;
};
